<div *ngIf="show" class="fixed inset-0 z-[1000] bg-black bg-opacity-50 flex items-center justify-center p-4">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[600px] p-6 relative flex flex-col">

      <!-- Modal Header -->
      <div class="flex items-center justify-between mb-4">
        <div class="flex flex-col">
          <h2 class="text-xl font-semibold text-[#1F2937]">SQL Playground</h2>
          <p class="text-sm text-[#667085]">
            Edit, re-execute, or explore your SQL query results with optional reduced security mode.
          </p>
        </div>
        <div class="flex space-x-4 items-center">
          <!-- Copy -->
          <div class="relative group cursor-pointer">
            <ui-icon name="copy" class="stroke-gray-900 stroke-2  hover:stroke-[#0F49A0]" size="size-5" (click)="copySQl()"></ui-icon>
            <div class="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded p-2 bottom-8 right-0 whitespace-nowrap">Copy SQL</div>
          </div>

          <!-- Run -->
          <div class="relative group" *ngIf="!isSqlEditable" 
          [ngClass]="{
            'cursor-pointer': !isRunSqlLoading || !disableRun,
            'cursor-not-allowed': isRunSqlLoading || disableRun
          }"
          >
            <img src="assets/icons/rerun.svg" alt="Rerun" class="w-5 h-5  " 
            [ngClass]="{
              'hover:opacity-80 stroke-gray-900': !isRunSqlLoading || !disableRun,
              ' opacity-50 stroke-gray-500': isRunSqlLoading || disableRun
            }"
            (click)="runSQL(true)" />
            <div class="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded p-2 bottom-8 right-0 whitespace-nowrap">Run SQL</div>
          </div>

          <!-- Edit -->
          <div class="relative group" *ngIf="!isSqlEditable">
            <ui-icon name="pencil" class="stroke-gray-900 " size="size-5"
              [ngClass]="{
                'cursor-pointer hover:stroke-[#0F49A0]': isLatestQuery&& !isRunSqlLoading,
                'cursor-not-allowed opacity-50': isLatestQuery || isRunSqlLoading
              }"
              (click)="isLatestQuery && !isRunSqlLoading && enableSqlEditing()">
            </ui-icon>
            <div class="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded p-2 bottom-8 right-0 whitespace-nowrap">Edit SQL</div>
          </div>

          <!-- Close -->
          <div class="relative group" 
          [ngClass]="{
            'cursor-pointer': !isRunSqlLoading,
            'cursor-not-allowed': isRunSqlLoading
          }"
          >
            <ui-icon name="close" class="stroke-gray-900  "
            [ngClass]="{
              'cursor-pointer hover:stroke-[#FF4D4F]': !isRunSqlLoading,
              'cursor-not-allowed opacity-50': isRunSqlLoading
            }"
            size="size-5" (click)="closeShowSqlModal()"></ui-icon>
            <div class="absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded p-2 bottom-8 right-0 whitespace-nowrap">Close</div>
          </div>
        </div>
      </div>

      <!-- Content Scrollable Area -->
  <div class="flex-1 overflow-hidden flex flex-col min-h-0">
    <div class="rounded-xl border-2 bg-white transition-all duration-200 flex-1 flex flex-col overflow-hidden"
      [ngClass]="{
        'border-red-500': !isSqlEditable && isSqlErrorResponse,
        'border-[#0F49A0] shadow-sm': isSqlEditable,
        'border-gray-300': !isSqlEditable && !isSqlErrorResponse
      }">

      <!-- SQL Viewer / Editor Section -->
      <div class="flex-1 overflow-auto font-mono text-sm whitespace-pre min-h-0">

        <!-- View Mode -->
        <div *ngIf="!isSqlEditable" class="h-full">
          <markdown [data]="this.formattedSqlHtml" class="block w-full p-4"></markdown>
        </div>

        <!-- Edit Mode -->
        <div *ngIf="isSqlEditable" class="h-full">
          <div contenteditable="true"
            class="w-full h-full p-4 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#0F49A0] bg-white text-black overflow-auto outline-none"
            (input)="onSqlContentEdit($event)"
            [innerHTML]="formattedSqlHtml"
            spellcheck="false">
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="border-t flex justify-end space-x-3 p-4">
        <span *ngIf="isRunSqlLoading" class="mt-1 flex items-center space-x-3">
          <div class="sql-execution-loader">
            <div class="pulse-dot"></div>
            <div class="pulse-dot"></div>
            <div class="pulse-dot"></div>
          </div>
          <span class="text-sm text-gray-600 font-medium animate-pulse">Executing query...</span>
        </span>
        <button *ngIf="isSqlEditable" class="px-4 py-2 rounded-md text-white text-sm font-medium" [ngStyle]="{ 'background-color': '#0F49A0' }" (click)="runSQL()">Run</button>
        <button *ngIf="isSqlEditable" class="px-4 py-2 rounded-md text-white text-sm font-medium" [ngStyle]="{ 'background-color': '#5D5D5D' }" (click)="isSqlEditable = false">Cancel</button>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="isSqlErrorResponse" class="mt-4 text-red-600 text-sm flex items-center">
      <ui-icon name="alert" class="stroke-red-500 mr-2" size="size-4"></ui-icon>
      <span>There was an error with your SQL query. Please check the syntax and try again.</span>
    </div>
  </div>

    </div>
  </div>